import React, { useEffect } from "react";
import "./Toast.css";

interface ToastProps {
  show: boolean;
  message: string;
  type?: "success" | "error";
  onClose: () => void;
}

export default function CustomToast({
  show,
  message,
  type = "error",
  onClose,
}: ToastProps) {

  useEffect(() => {

    if(show){
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }

  }, [show]);

  if (!show) return null;

  return (
    <div className={`toast-container ${type}`}>
      <span>{message}</span>

      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}